<template>
  <div>
    <v-toolbar color="page-toolbar">
      <v-toolbar-title class="text-body-large"> Liste des Stations <small>(Administration)</small> </v-toolbar-title>
    </v-toolbar>

    <v-card>
      <v-btn class="fab-absolute-top-right" color="success" @click="$router.push({ name: 'admin-gauge-add' })" icon size="large">
        <v-icon> mdi-plus </v-icon>
      </v-btn>
      <v-alert type="info" class="mt-3">
        La colonne "Sections de rivière" affiche une valeur mise à jour toutes les 24 heures.
      </v-alert>
      <v-card-title class="d-flex flex-wrap align-center ga-2">
        Stations
        <v-spacer></v-spacer>
        <v-select
          v-model="typeFilter"
          :items="typeOptions"
          label="Filtrer par type"
          single-line
          hide-details
          density="compact"
        ></v-select>
        <v-btn v-if="typeFilter" icon size="small" @click="clearFilter">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredGauges"
        :search="search"
        :items-per-page="-1"
        :loading="loadingGauges"
        no-data-text="Aucune jauge disponible"
        items-per-page-text="Éléments par page"
      >
        <template v-slot:loading>
          <v-skeleton-loader type="table-row@8"></v-skeleton-loader>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon size="small" class="mr-2" @click="editGauge(item)" color="primary"> mdi-pencil </v-icon>
        </template>
        <template v-slot:[`item.active`]="{ item }">
          <v-icon v-if="item.active" color="green"> mdi-check </v-icon>
          <v-icon v-else color="red"> mdi-close </v-icon>
        </template>
        <template v-slot:[`item.riverSections`]="{ item }">
          {{ item.river_sections_count || 0 }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import "firebase/compat/firestore";

  export default {
    data() {
      return {
        search: "",
        typeFilter: null,
        typeOptions: ["CEHQ", "Hydro-Quebec"],
        headers: [
          { title: "Nom", align: "start", key: "name" },
          { title: "Description", key: "description" },
          { title: "Type", key: "type" },
          { title: "Actif", key: "active" },
          { title: "ID", key: "id" },
          {
            title: "Sections de rivière",
            key: "river_sections_count", // Ensure this matches the property in the data
            sortable: true, // Enable sorting for this column
          },
          { title: "Action", key: "actions" },
        ],
        gauges: [], // Includes both CEHQ and Hydro-Quebec gauges
        loadingGauges: true,
      };
    },
    async created() {
      try {
        this.gauges = await this.getAllGauges();
      } finally {
        this.loadingGauges = false;
      }
    },
    computed: {
      filteredGauges() {
        if (!this.typeFilter) return this.gauges;
        return this.gauges.filter((gauge) => gauge.type === this.typeFilter);
      },
    },
    methods: {
      async getAllGauges() {
        return await this.$store.dispatch("bindGauges");
      },
      editGauge(gauge) {
        var slug = gauge.id;
        console.log("Edit gauge:", gauge);
        this.$router.push({ name: "admin-gauge-edit", params: { slug: slug, gauge: gauge } });
      },
      clearFilter() {
        this.typeFilter = null;
      },
    },
  };
</script>
